import PropTypes from "prop-types";
import styles from "./styles.module.css"

export default function AccordionItem({ item, isOpen, onToggle }) {
  return (
    <article className={styles["accordion-item"]}>
      <button
        type="button"
        className={styles["accordion-item__header"]}
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <span>{item.title}</span>

        <img
          src="/ui/images/Truman-UI-Icon-Arrow.svg"
          alt=""
          className={`${styles["accordion-item__icon"]} ${
            isOpen ? styles["accordion-item__icon--open"] : ""
          }`}
        />
      </button>

      {isOpen && (
        <div className={styles["accordion-item__content"]}>
          <p className="m-0">{item.description}</p>
        </div>
      )}
    </article>
  );
}
AccordionItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    description: PropTypes.string,
  }),
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
};
